import { OrderWizard } from '@/modules/order/components/OrderWizard/OrderWizard.tsx';
import { useTranslation } from 'react-i18next';
import { DocumentTitle } from '@/shared/components/DocumentTitle.tsx';
import { FullscreenLoadingSuspenseBoundary } from '@/shared/components/FullscreenLoadingSuspenseBoundary.tsx';
import { BeforeUnloadContextProvider } from '@/shared/context/BeforeUnloadContext.tsx';
import { OrderContextProvider } from '@/modules/order/context/OrderContext.tsx';
import { PageHeader } from '@/shared/components/PageHeader';
import { BalanceSheetContextProvider } from '@/shared/components/ProductGroupHeader/context/BalanceSheetContext';
import { GetPositionConfigurationResponse } from '@/shared/types/positionV2/api/get-position-configuration.ts';

export function OrderPage({ positionV2 }: { positionV2?: GetPositionConfigurationResponse }) {
    const { t } = useTranslation();

    return (
        <>
            <DocumentTitle title={t('page.title')} />
            <FullscreenLoadingSuspenseBoundary>
                <BalanceSheetContextProvider>
                    <OrderContextProvider positionV2={positionV2}>
                        <BeforeUnloadContextProvider defaultEnabled>
                            <div className="bg-light-gray-200 flex min-h-screen flex-col items-center p-6">
                                <PageHeader title={t('page.title')} onCloseClickPath="/dashboard" />
                                <OrderWizard />
                            </div>
                        </BeforeUnloadContextProvider>
                    </OrderContextProvider>
                </BalanceSheetContextProvider>
            </FullscreenLoadingSuspenseBoundary>
        </>
    );
}
